import { useSelect } from '~/store'
import { stOrganizationModule } from './st-organization-module'
import { OrganizationRole } from '@st/sdk'
import { useCurrentUser } from '../app-hooks'

export function useOrganizationRole(): OrganizationRole {
  const user = useCurrentUser()
  const organizationRole = useSelect('stOrganization', (s) =>
    s.status == 'loaded'
      ? s.organizationState.memberships.find((membership) => membership.user.id == user?.id)?.role
      : undefined
  )
  return organizationRole ?? 'restricted'
}
